import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClientCustom } from './http-client';
import { SERVICE_URL } from '../constants/global';
import { ReturnStatusHtml } from '../models/returnStatus';
import { MasterService } from './master.service';
import { CostCenterDistribution } from '../models/cost-center-distribution';

@Injectable()
export class CostCenterDistributionService {

  private _controller: string = 'CostCenterDistribution';

  constructor(
    private http: HttpClientCustom, 
    private _masterService: MasterService
  ) { }

  updateCostCenterDistributions(id: number, context: string, ccd: CostCenterDistribution[]): Observable<ReturnStatusHtml> {
    return this.http.put(SERVICE_URL + this._controller + '/UpdateCostCenterDistributions?id='+id+'&context='+context, ccd).pipe(
      map((response: any) => this._masterService.convertToReturnStatusHtml(response)));
  }

}
